import { WebAppError } from '../../../errors/web-app.error';

import { SearchParams } from '@interfaces/modules/tours/search';

export class IrrelevantSearchError extends WebAppError {
  constructor(readonly params: SearchParams) {
    super('Search includes outdated dates');
  }
}
